import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

const BlogCard = ({ blog }) => {
    const navigate = useNavigate();

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Date(dateString).toLocaleDateString('en-US', options);
    };

    const handleClick = () => {
        navigate(`/jetsetter/blog/${blog.page_url}`);
    };

    return (
        <div 
            className="bg-white rounded-lg shadow-sm overflow-hidden hover:shadow-md transition-shadow cursor-pointer"
            onClick={handleClick}
        >
            {/* Image */}
            <div className="relative h-56 bg-gray-100">
                {blog.image ? (
                    <img
                        src={`/admin/storage/blogs/${blog.image}`}
                        alt={blog.title || blog.page_name}
                        onError={(e) => {
                            e.target.onerror = null; 
                            e.target.src = '/hero-image.jpeg';
                        }}
                        className="w-full h-full object-cover"
                    />
                ) : (
                    <div className="w-full h-full bg-gray-200 flex items-center justify-center">
                        <span className="text-gray-400">No Image</span>
                    </div>
                )}
            </div>

            {/* Content */}
            <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2 line-clamp-2">
                    {blog.title || blog.page_name}
                </h3>
                <p className="text-gray-600 text-sm mb-4 line-clamp-3">
                    {blog.summary || blog.text_content || ''}
                </p>
                
                <div className="pt-3 border-t border-gray-100">
                    <div className="flex items-center gap-3 text-sm text-gray-600 mb-3">
                        <span className="flex items-center gap-1.5">
                            <i className="fas fa-user text-[#ffd200]"></i>
                            <span>{blog.created_by || blog.author || 'Jamie C'}</span>
                        </span>
                        <span className="flex items-center gap-1.5">
                            <i className="fas fa-calendar text-[#ffd200]"></i>
                            <span>{formatDate(blog.created_at)}</span>
                        </span>
                    </div>
                    <div className="text-[#ffd200] hover:text-[#e6bd00] font-bold text-2xl flex items-center gap-2 transition-colors cursor-pointer">
                        Read More <FontAwesomeIcon icon={faArrowRight} className="text-xl" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BlogCard;
